import { render } from "./ModalError.vue?vue&type=template&id=425842df&scoped=true"
import script from "./ModalError.vue?vue&type=script&lang=js"
export * from "./ModalError.vue?vue&type=script&lang=js"

import "./ModalError.vue?vue&type=style&index=0&id=425842df&rel=scss&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425842df"]])

export default __exports__